import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import EntityStateUpdater from 'component/EntityStateUpdater';

import Entity from 'components/Entity';
import Data from 'components/Data';

import ItemDetails from 'js/pages/Account/ItemDetails';
import ItemVariantDetails from 'js/pages/Account/ItemVariantDetails';
import CarDetails from 'js/pages/Account/CarDetails';

import { entityMetaMapping } from 'js/constants';

class Item extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();

    // if we get item data from the outside, we can pass it on to our data entity
    if (props.itemData) {
      this.entity.setData(props.itemData);
    }

    if (props.meta[entityMetaMapping.item] !== undefined && !props.meta[entityMetaMapping.item].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.item);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = prevProps => {
    const { match, meta, data } = this.props;
    const { entityLoaded } = this.state;

    if (prevProps.match.params.itemId !== match.params.itemId) {
      this.setState({ entityLoaded: false, entityChanged: false });
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (
      meta[entityMetaMapping.item] !== undefined &&
      !meta[entityMetaMapping.item].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.item);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (entityLoaded && prevProps.data.data.assets && data.data && data.data.assets) {
      // image has been uploaded, update the item image list
      // another possibility: image has been deleted
      if (
        (prevProps.data.data.assets.imgs && prevProps.data.data.assets.imgs.length !== data.data.assets.imgs.length) ||
        (!prevProps.data.data.assets.imgs && data.data.assets.imgs) ||
        (prevProps.data.data.assets.imgs && !data.data.assets.imgs)
      ) {
        const imgs = [];
        for (let i = 0; i < data.data.assets.imgs.length; i++) {
          imgs.push(this.state.entity.createValue('imgs', ['assets'], data.data.assets.imgs[i]));
        }

        if (data.data.assets.imgs.length > 1) {
          this.updateEntity('imgs', imgs, ['assets']);
        } else if (data.data.assets.imgs.length === 1) {
          this.updateEntityMultiple(['defaultImg', 'imgs'], [imgs[0], imgs], [[], ['assets']]);
        } else {
          this.updateEntityMultiple(['defaultImg', 'imgs'], [null, []], [[], ['assets']]);
        }
      }
    }
  };

  render() {
    const { data, type } = this.props;
    const { entityLoaded, entity, entityChanged } = this.state;

    return (
      <div>
        {/* data should not be fetched if we got the data as props */}
        {/* we do need the meta data though */}
        {this.props.itemData !== undefined || this.props.match.params.itemId === undefined ? (
          <Data dataName="item" />
        ) : (
          <Data dataName="item" url={'/api/items/' + this.props.match.params.itemId + '.json'} data={data} />
        )}

        {type === 'car' && (
          <CarDetails
            {...this.props}
            entity={entity}
            entityLoaded={entityLoaded}
            entityChanged={entityChanged}
            changeEntity={this.changeEntity}
          />
        )}
        {type === 'item' && (
          <ItemDetails
            {...this.props}
            entity={entity}
            entityLoaded={entityLoaded}
            entityChanged={entityChanged}
            changeEntity={this.changeEntity}
          />
        )}
        {type === 'itemVariant' && (
          <ItemVariantDetails
            {...this.props}
            entity={entity}
            entityLoaded={entityLoaded}
            entityChanged={entityChanged}
            changeEntity={this.changeEntity}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.item,
    meta: state.entityMeta,
  };
};

export default withRouter(connect(mapStateToProps)(Item));
